













import Vue from 'vue';

export default Vue.extend({
  name: 'Loader',
  props: {
    cls: {
      required: false,
      type: String,
    },
  },
});
